// extracted by mini-css-extract-plugin
export default {"container":"sortable-images-preview-panel_container__3dmuP","loading":"sortable-images-preview-panel_loading__ZHaMC"};